import { useState } from "react";
import type { OwnHomeInputs } from "web_myplann/Inspiration/Utils/ownHomeMath";

export type OwnHomeSheet =
	| "quick"
	| "expenses"
	| "affordability-edit"
	| "create-goal"
	| null;

export const useOwnHomeJourney = () => {
	const [inputs, setInputs] = useState<OwnHomeInputs>({});
	const [activeSheet, setActiveSheet] = useState<OwnHomeSheet>(null);

	const submitQuick = (data: {
		rent: number;
		income: number;
		savings?: number;
	}) => {
		setInputs((prev) => ({ ...prev, ...data }));
		setActiveSheet(null);
	};

	const submitExpenses = (expenses: number) => {
		setInputs((prev) => ({ ...prev, expenses }));
		setActiveSheet(null);
	};

	const submitAffordabilityEdit = (data: {
		income: number;
		expenses?: number;
	}) => {
		setInputs((prev) => ({ ...prev, ...data }));
		setActiveSheet(null);
	};

	return {
		inputs,
		activeSheet,
		openSheet: setActiveSheet,
		closeSheet: () => setActiveSheet(null),
		submitQuick,
		submitExpenses,
		submitAffordabilityEdit,
	};
};
